module.exports = __webpack_public_path__ + "img/63.8413af63.jpg";